/* eslint-disable */
import { FormField, MultiSelectControlField } from 'src/lib';
import { IFilterToDataMap } from '../../common/features/filters/models/filter-to-data-map';

export default function getInnovationPayload(
  filterValuesFromFormik: { [key: string]: { label: string; value: string }[] },
  masterFiltersData: IFilterToDataMap | any
) {
  const masterData = masterFiltersData.filters;

  if (!filterValuesFromFormik) {
    return [];
  }

  // getting formik array of objects
  const formikObject = Object.keys(filterValuesFromFormik).map((key) => ({
    field_name: key,
    field_values: filterValuesFromFormik[key].map((e) => e.value)
  }));

  // initializing array for storing filter values
  const finalInputs = [];

  for (let i = 0; i < formikObject.length; i++) {
    // getting curr filter object from master data to compare with default values
    const currFilterObj: any = masterData.filter(
      (e) => e.name === formikObject[i].field_name
    )[0];
    let currObj = {
      field_name: '',
      field_values: []
    };
    // getting the field name nme in currObj
    currObj.field_name = formikObject[i].field_name;
    // getting the field values nme in currObj
    currObj.field_values = formikObject[i].field_values;

    // pushing the filter values only if they are changed as per the default values
    if (currObj.field_values.length !== currFilterObj.values.length) {
      // pushing the modified values of filters in the finalInputs array
      finalInputs.push(currObj);
    }
  }
  // return finalInputs.filter((field) => field.field_values.length);
  return finalInputs;
}
